"use client"

import { motion } from "framer-motion"

export function VisualiseurLoader() {
  return (
    <div className="flex items-end justify-center gap-1.5 h-8">
      {[...Array(5)].map((_, i) => (
        <motion.div
          key={i}
          className="w-1.5 rounded-full bg-[#E31D2B]"
          animate={{
            height: ["20%", "100%", "20%"],
            opacity: [0.5, 1, 0.5]
          }}
          transition={{
            duration: 0.8,
            repeat: Infinity,
            delay: i * 0.1,
            ease: "easeInOut"
          }}
        />
      ))}
    </div>
  )
}